"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isManualDonor = void 0;
const types_1 = require("./types");
function isManualDonor(donorId) {
    return donorId === types_1.MANUAL_DONOR_ID;
}
exports.isManualDonor = isManualDonor;
